  // src/App.jsx
  import React from 'react';
  import { ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
  import 'react-datepicker/dist/react-datepicker.css';
  import RouteConfig from './routes/RouteConfig'; // ✅ Use central route config
  const App = () => {
    return (
      <>
        <RouteConfig /> {/* ✅ This replaces all route declarations */}
        <ToastContainer position="top-right" autoClose={3000} />
        
      </>
    );
  };

  export default App;
